// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team {
  background: #fff;
}

.team__head {
  margin-bottom: 44px;
}

.team__grid {
  display: flex;
  justify-content: center;
}

.team__grid .team-card {
  width: 100%;
  max-width: 340px;
}

.team-card {
  text-align: center;
  padding: 30px 18px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-soft);
  background: var(--bg-light);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.team-card:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-sm);
}

.team-card__avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 20px;
  color: #fff;
}

.team-card__avatar--teal {
  background: linear-gradient(135deg, var(--teal), var(--teal-dark));
  box-shadow: var(--shadow-teal);
}

.team-card__avatar--amber {
  background: linear-gradient(135deg, var(--amber), var(--amber-dark));
  box-shadow: var(--shadow-amber);
}

.team-card h3 {
  font-size: 15.5px;
  font-weight: 700;
  margin-bottom: 10px;
}

.team-card .pill {
  margin-bottom: 12px;
}

.team-card p {
  font-size: 12.8px;
  line-height: 1.6;
}

`, "",{"version":3,"sources":["webpack://./src/components/Team.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,oCAAoC;EACpC,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kEAAkE;EAClE,8BAA8B;AAChC;;AAEA;EACE,oEAAoE;EACpE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".team {\n  background: #fff;\n}\n\n.team__head {\n  margin-bottom: 44px;\n}\n\n.team__grid {\n  display: flex;\n  justify-content: center;\n}\n\n.team__grid .team-card {\n  width: 100%;\n  max-width: 340px;\n}\n\n.team-card {\n  text-align: center;\n  padding: 30px 18px;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-soft);\n  background: var(--bg-light);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.team-card:hover {\n  transform: translateY(-6px);\n  box-shadow: var(--shadow-sm);\n}\n\n.team-card__avatar {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  margin: 0 auto 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--font-display);\n  font-weight: 800;\n  font-size: 20px;\n  color: #fff;\n}\n\n.team-card__avatar--teal {\n  background: linear-gradient(135deg, var(--teal), var(--teal-dark));\n  box-shadow: var(--shadow-teal);\n}\n\n.team-card__avatar--amber {\n  background: linear-gradient(135deg, var(--amber), var(--amber-dark));\n  box-shadow: var(--shadow-amber);\n}\n\n.team-card h3 {\n  font-size: 15.5px;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n.team-card .pill {\n  margin-bottom: 12px;\n}\n\n.team-card p {\n  font-size: 12.8px;\n  line-height: 1.6;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
